import { render, staticRenderFns } from "./wlCarousel.vue?vue&type=template&id=2bb891ea&scoped=true&"
import script from "./wlCarousel.vue?vue&type=script&lang=js&"
export * from "./wlCarousel.vue?vue&type=script&lang=js&"
import style0 from "./wlCarousel.vue?vue&type=style&index=0&id=2bb891ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb891ea",
  null
  
)

export default component.exports